import Urls from '../urls'
import Request from '../request'

import FilesUtils from './utils'

export function copyFile(sourcePath, targetPath, asyncHandler) {
  const parameters = {
    sourcePath: FilesUtils.ensureSlashInPath(sourcePath),
    targetPath: FilesUtils.ensureSlashInPath(targetPath)
  }

  return Request.put({
    url         : Urls.fileCopy(),
    data        : parameters,
    isAsync     : !!asyncHandler,
    asyncHandler: asyncHandler
  })
}




// WEBPACK FOOTER //
// ./src/files/copy.js